import { useState, useMemo, useEffect, useRef } from "react";

import { clearAllTableFilters, onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../redux/features/table/tableSlice";
import TableFilters from "../../../Components/common/TableGrid/TableFilters";
import TableTabs from "../../../Components/common/TableGrid/TableTabs";
import TableGrid from "../../../Components/common/TableGrid";

import { ReactComponent as tripstoday } from '../../../assets/images/icon_svg/pieceee.svg';
import { ReactComponent as onpremises } from '../../../assets/images/icon_svg/dis_icon.svg';
import { ReactComponent as inprogress } from '../../../assets/images/icon_svg/truck_icon.svg';
import { ReactComponent as arriving } from '../../../assets/images/slotplanning/arriving.svg';
import { useSelector, useDispatch } from "react-redux";
import { useToggleSlotStatusMutation, useAwbViewQuery, useLazyAwbDetailsQuery } from "../../../redux/services/ARFSM";

import { ReactComponent as EyeIcon } from "../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { ReactComponent as Warning } from "../../../assets/images/icon_svg/warning.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as RouteIcon } from "../../../assets/images/route.svg";
import CommonCard from "../../../Components/common/CommonCard";
import { toast } from "react-toastify";
import ConfModal from "../../../Components/common/ConfModal";
import { withRFSToken } from "../../../Services/axios";
import { GETDESTINATION } from "../../../Utils/conts";
import { Container, Row, Col, Form, InputGroup, Button, ListGroup, Badge, Accordion, Modal, Card, Nav, Tabs, Tab } from "react-bootstrap";
import { ReactComponent as TransPice } from "../../../assets/images/icon_svg/trans_pice.svg";
import { ReactComponent as DangerError } from "../../../assets/images/icon_svg/danger_error.svg"; 
import { ReactComponent as Overview } from "../../../assets/images/icon_svg/overview.svg"; 
import { ReactComponent as Status } from "../../../assets/images/icon_svg/status.svg";  
import { ReactComponent as Plane } from "../../../assets/images/icon_svg/gray_plane.svg"; 
import { ReactComponent as Attachment } from "../../../assets/images/icon_svg/gray_attach.svg";
import { ReactComponent as GrayTruck } from "../../../assets/images/icon_svg/gray_truck.svg";
import { ReactComponent as GrayClock } from "../../../assets/images/icon_svg/gray_clock.svg";
import { ReactComponent as Open } from "../../../assets/images/icon_svg/open_icon.svg";
import { ReactComponent as BluePlane } from "../../../assets/images/icon_svg/blue_plan.svg";
import { ReactComponent as PurplePlane } from "../../../assets/images/icon_svg/purple_plane.svg"; 
import { ReactComponent as Truck } from "../../../assets/images/icon_svg/red_truck.svg"; 
import { ReactComponent as OrangeTruck } from "../../../assets/images/icon_svg/orange_truck.svg"; 
import { ReactComponent as UploadHistory } from "../../../assets/images/icon_svg/upload_history.svg"; 
import { ReactComponent as Delete } from "../../../assets/images/icon_svg/upload_history.svg"; 
import AwbDetailsModal from "./Components/AwbDetailsModal";



const AwbView = ({ onDetails }) => {

  const isMounted = useRef(false);
  const [awbDetailData, setAwbDetailData] = useState(null);
  const [modalConf, setModalConf] = useState(false);
  const [shows, setShows] = useState(false);
  const [activeFilter, setActiveFilter] = useState(false);
  const [preFilter, setPreFilter] = useState(false);
  const [confData, setConfData] = useState({});
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const dispatch = useDispatch();
  const [getDestination, setGetDestination] = useState([]);
  const fetchDestination = async () => {
      try {
          const res = await withRFSToken.post(GETDESTINATION, {})
              .then(function (res) {
                  const innerData = res.data.response_data;
                  const transformedData = innerData ? innerData.map(item => ({
                      value: item.port_code,
                      label: item.port_code,
                      // address: item.address,
                      // station_id: item.station_id
                  })) : [];
                  setGetDestination(transformedData);
                  // dispatch(onChangeFilters({ ...filters, loading_station: ["FRA"] }));
                  // const sFilter = { loading_station: ['FRA'] };
                  // localStorage.setItem('PreFilter', JSON.stringify(sFilter));
                  // setPreFilter(true)
              });

      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };
   useEffect(() => {
      localStorage.removeItem('TOInitialTab');
      localStorage.removeItem('TODetails');
     dispatch(onTabChange({ key: 'tab', value: "A" }));
      if (isMounted.current) return;
      fetchDestination();
      isMounted.current = true;
    //    setTimeout(() => {
    //     const sFilter = { loading_station: ['FRA'] };
    //     localStorage.setItem('PreFilter', JSON.stringify(sFilter));
    //     dispatch(onChangeFilters(sFilter));
    //     setPreFilter(true);
    // }, 0);
  }, []);

   const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value); // [187,186]
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
      recordstartindex: pageDetails.recordstartindex,
      recordendindex: pageDetails.recordendindex,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }

    if (tab?.value && tab.value !== "all" && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useAwbViewQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const filtersConfig = [
    {
      type: "input",
      field: "awb_no",
      placeholder: "Search AWB No.",
    },
    {
      type: "input",
      field: "truck_flight_no",
      placeholder: "Search Truck No.",
      // options: [
      //   {label: "Planned" , value: "Planned"},
      //   {label: "Shipments Received" , value: "Shipments Received"},
      //   {label: "Manifested" , value: "Manifested"},
      //   {label: "Departed" , value: "Departed"},
      //   {label: "Arrived" , value: "Arrived"},
      // ],
    },
    {
      type: "multiselect",
      field: "order_status",
      placeholder: "Status",
      class: 'dw-13',
      options: [
        {label: "Arrived" , value: "Arrived"},
        {label: "Departed" , value: "Departed"},
        {label: "Manifested" , value: "Manifested"},
        {label: "Shipments Received" , value: "Shipments Received"},
        {label: "Planned" , value: "Planned"},
      ],
    },
    {
      type: "multiselect",
      field: "board_point",
      placeholder: "Boardpoint",
      class: 'dw-13',
      options: getDestination?.map((item) => ({
        label: item.label,
        value: item.value,
      })) || [],
    },
    {
      type: "multiselect",
      field: "off_point",
      placeholder: "Offpoint",
      class: 'dw-12',
      options: getDestination?.map((item) => ({
        label: item.label,
        value: item.value,
      })) || [],
    },
  ];
  const tabsConfig = [
    { label: "All", value: "all", paramKey: 'tab' },
    { label: "Open", value: "A", paramKey: "tab" },
    { label: "Archive", value: "R", paramKey: "tab" },
  ]; 

  // const dispatch = useDispatch();
  const [triggerAwbDetails, { data, isLoading, error }] = useLazyAwbDetailsQuery();
  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: 'single_action', cls: 'tw-3',
      renderCell: (row) => (<div className="tb_grid_actions">
        <EyeIcon className="icon_light_gray" style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            loadDetails(row);
          }}
        />
      </div>),
    },
    { label: "DIS", field: "dis", enableSearch: false, cls: 'tw-3', renderCell: (row) => {
        if(row?.discrepancy){
          return(<><Warning /></>)
        }
      }
    },
    { label: "AWB No.", field: "awb_no", enableSearch: false, cls: 'tw-6' },
    { label: "Pieces", field: "total_pcs", enableSearch: false, cls: 'tw-5' },
    { label: "Weight", field: "total_weight", enableSearch: false, cls: 'tw-5' },
    { label: "Status", field: "order_status", enableSearch: false, cls: 'tw-5',    },
    { label: "Route", field: "trip_type", enableSearch: false, cls: 'tw-6',
      renderCell: (row) => {
        const boardPoint = row?.truck_order_mapping?.truck_load_plan?.board_point;
        const offPoint = row?.truck_order_mapping?.truck_load_plan?.off_point;
        return (
          <>
            <div className="d-flex justify-content-between route_info">
              <span className="stat-txt">{boardPoint || "-"}</span>
              <span className="stat-txt">{offPoint || "-"}</span>
            </div>
            <RouteIcon className="route_icon" />
          </>
        );
      },
    },
    { label: "Truck No", field: "truck_load_awb", enableSearch: false, cls: 'tw-6', renderCell : (row) => {
      const truck_no = row?.truck_order_mapping?.truck_load_plan?.truck_flight_no
      return(<>{truck_no}</>)
    } },
    { label: "STD", field: "std", enableSearch: false, cls: "tw-6", renderCell: (row) => {
        const std = row?.truck_order_mapping?.truck_load_plan?.truck_stds;
        return (
          <>
            {std ? std : ""}
          </>
        );
      },
    },
    { label: "STA", field: "sta", enableSearch: false, cls: 'tw-6',renderCell: (row) => {
        const sta = row?.truck_order_mapping?.truck_load_plan?.truck_stas;
        return (
          <>
            {sta ? sta : ""}
          </>
        );
      }, },
    { label: "Trucker Planned", field: "planned_pcs", enableSearch: false, cls: 'tw-7' },
    { label: "Received Loading", field: "loading_received_display", enableSearch: false,
     renderCell: (row) => <span style={{ color: row?.loading_received_display?.includes("-") && row?.loading_received_display?.includes("(") ? "#EF4444" : "inherit" }}>{row?.loading_received_display}</span>,
    },
    { label: "MAN", field: "loading_man_display", enableSearch: false,
     renderCell: (row) => <span style={{ color: row?.loading_man_display?.includes("-") && row?.loading_man_display?.includes("(") ? "#EF4444" : "inherit" }}>{row?.loading_man_display}</span>,
      cls: 'tw-5'
    },
    { label: "DEP", field: "loading_dep_display", enableSearch: false,
      renderCell: (row) => <span style={{ color: row?.loading_dep_display?.includes("-") && row?.loading_dep_display?.includes("(") ? "#EF4444" : "inherit" }}>{row?.loading_dep_display}</span>,
      cls: 'tw-5'
    },
    { label: "ARR", field: "unloading_arr", enableSearch: false, cls: 'tw-5', renderCell: (row) => {
        const value = row?.unloading_arr;
        return <>{value ?? "-"}</>;
      }, },
    { label: "RCF - Offpoint", field: "unloading_rcf", enableSearch: false, cls: 'tw-6',  renderCell: (row) => {
        const value = row?.unloading_rcf;
        return <>{value ?? "-"}</>;
      },},
    { label: "Last Updated", field: "updated_at", enableSearch: false, renderCell: (row) => {
        const lastupdatedate = row?.updated_at;
        return (
          <>
            {lastupdatedate ? new Date(lastupdatedate).toLocaleString("en-GB", { timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false,}) : ""}
          </>
        );
      }, cls: 'tw-6'},
    { label: "Inbound Flight No.", field: "unloading_rcf", enableSearch: false, cls: 'tw-6', renderCell : (row) => {
      const inb_flight_no = row?.truck_load_awb?.inbound_flight_no;
       return(<>{inb_flight_no}</>)
    }},
    { label: "Inbound Flight Date", field: "unloading_rcf", enableSearch: false, cls: 'tw-6',renderCell: (row) => {
        const inb_flight_date = row?.truck_load_awb?.inbound_flight_date;
        return (
          <>
            {inb_flight_date ? new Date(inb_flight_date).toLocaleString("en-GB", { timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false,}) : ""}
          </>
        );
      },},
    { label: "Inbound Flight ULD", field: "unloading_rcf", enableSearch: false, cls: 'tw-6',renderCell: (row) => {
        const inb_flight_uld = row?.truck_load_awb?.units_loaded;
        return (<>{inb_flight_uld}</>);
      }},
    { label: "SHC", field: "unloading_rcf", enableSearch: false ,  renderCell: (row) => {
        const shc = row?.truck_load_awb?.shc;
        return (
          <>
            {shc?.replaceAll("-", ", ")}
          </>
      );},}
  ];

    const handleMoveToActArc = () => {
          const isActiveTab = tab?.value === 'A';
          setConfData({
            header: `Selected Data move to ${isActiveTab ? 'Archive' : 'Active'}`,
            subHeader: `Are you sure you want to ${isActiveTab ? 'Archive' : 'Activate'}?`,
            primaryBtn: 'Confirm',
            secondaryBtn: 'Cancel',
            modalConf: tabChangeConf,
          });
          setModalConf(true);
        };
        const tabChangeConf = async () => {
          const isActiveTab = tab?.value === 'A';
          const payload = {
            ids: selectedRows.map(row => row.id),
          };
          try {
            const res = await withRFSToken.post('toggle-truck-status',payload);
            if (res.data.response_code === 200) {
              dispatch(clearSelectedRowsData(true));
              toast.success(res.data.response_msg)
              setModalConf(false);
              refetch();
            } else {
              toast.error(res.data.response_msg);
            }
          } catch (error) {
            console.error('Error updating status:', error);
            toast.error('Something went wrong');
          }
        };
        const confModalClose = () => {
        setModalConf(false);
        }
  const bulkActions = tab?.value === "A"
    ? [{ label: "Archive", action: handleMoveToActArc, icon: ArchiveIcon }]
    : tab?.value === "R"
      ? [{ label: "Activate", action: handleMoveToActArc, icon: ArchiveIcon }]
      : [];

  const cards = [
    { icon: 'tripstoday', title: 'Open RFS Shipments', value: myData?.ActiveAwbCount },
    { icon: 'onpremises', title: 'Discrepancies', value: myData?.TotalDiscrepancy },
    { icon: 'inprogress', title: 'In Transit', value: myData?.InTransit },
    { icon: 'arriving', title: ' - ', value: myData?.nextTwoHours },
  ]
  const iconMap = { tripstoday, onpremises, inprogress, arriving, };

  const loadDetails = async (row) => {
    try {
        const res = await triggerAwbDetails(row.awb_no).unwrap();
        setAwbDetailData(res);
        setShows(true);
    } catch (err) {
        console.error(err);
    }
};

  return (
    <>
    {modalConf &&
          <ConfModal
              header={confData.header}
              subHeader={confData.subHeader}
              modalConf={confData.modalConf}
              closeModal={confModalClose}
              primaryBtn={confData.primaryBtn}
              secondaryBtn={confData.secondaryBtn}
          />
      }
      <div className="main-content">
        {cards?.length ?
          <div className="card-bx">
            {cards?.map((item, index) => (
              <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} />
            ))}
          </div>
          : <></>
        }
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} pref={preFilter} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={myData?.Rows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            onClickRow={(row) => {
              console.log("Clicked Row:", row);
            }}
            loading={isFetching}
            // bulkActions={bulkActions}
            rowKey="id"
             pref={preFilter}
          />
        </div>
      </div>
      <AwbDetailsModal
        show={shows}
        key={awbDetailData?.header?.id}
        onHide={() => setShows(false)}
        awbData={awbDetailData}
        onDetails={onDetails}
      />
    </>
  )
}

export default AwbView